import { getHeaderHeight } from "../../utils/helpers";

export default () => {
    const navigation = document.querySelector(".mobile-navigation");
    if (navigation) {
        const toggle = navigation.querySelector(
            ".navigation--toggle .hamburger"
        );
        const container = navigation.querySelector(".navigation--content");
        const menu = navigation.querySelector(
            ".navigation--content > .menu-items"
        );

        if (menu) {
            const menuItems = menu.querySelector(".menu-items");
            const menuItem = menu.querySelectorAll(".menu-item");

            toggle.addEventListener("click", () => {
                let headerHeight = getHeaderHeight();
                const navContainer = navigation.querySelector(".navigation");
                const alertBanner = document.querySelector(".alert-banner");

                if (
                    navContainer.classList.contains("navigation--scrolled") &&
                    alertBanner &&
                    !alertBanner.hasAttribute("hidden")
                ) {
                    headerHeight -= alertBanner.offsetHeight;
                }
                container.style.top = `${headerHeight}px`;

                toggle.classList.toggle("is-active");
                container.classList.toggle("open");
                menu.classList.toggle("open");

                if (!menu.classList.contains("open")) {
                    menuItems.classList.remove("open");
                    container.classList.remove("open-child");
                }
            });

            menuItem.forEach((item) => {
                const openButton = item.querySelector(
                    ".menu-item--open-children"
                );

                if (openButton) {
                    openButton.addEventListener("click", (e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        const nextMenuList = item.querySelector(".menu-items");
                        console.log(nextMenuList);
                        if (nextMenuList) {
                            item.classList.toggle("open-child");
                            nextMenuList.classList.toggle("open");
                        }
                        container.classList.add("open-child");
                    });
                }
            });
        }
    }
};
